import "./SidebarDrawer.css";

import { Drawer } from "antd";

import { Sidebar } from "../Sidebar/Sidebar";

interface SidebarDrawerProps {
  open: boolean;
  setOpen: (value: boolean) => void;
}
export const SidebarDrawer = ({ open, setOpen }: SidebarDrawerProps) => {
  const onClose = () => {
    setOpen(false);
  };

  return (
    <Drawer
      title=""
      placement={"left"}
      closable={false}
      onClose={onClose}
      open={open}
      className="sidebarDrawer"
      width={250}
    >
      <Sidebar collapsed={false} setCollapsed={() => setOpen(false)} />
    </Drawer>
  );
};
